'use client';
import { CatModal, CatHeading } from 'components/blocks-components';
import { MultiModalProps } from '../../types';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import styles from './multi-equipment-modal.module.scss';

export const MultiEquipmentModal = ({
  children
}: Readonly<MultiModalProps>) => {
  const t = useTranslations();
  const [isOpen, setIsOpen] = useState(true);
  const onMultiModalClose = () => {
    window.history.pushState({}, '', window.location.pathname);
    setIsOpen(false);
  };

  return (
    <CatModal
      isActive={isOpen}
      size="sm"
      disableBackdropClick={true}
      onBlModalCancel={() => onMultiModalClose()}
      className={styles['multimodal-wrapper']}
    >
      <CatHeading
        slot="header"
        variant="title-sm"
        data-testid="multiEquipmentPopUp"
      >
        {t('SELECT_EQUIPMENT')}
      </CatHeading>
      {children}
    </CatModal>
  );
};
